import useSWR from 'swr';

const { REACT_APP_API_BASE_URL } = process.env;

const useRolePermissions = (role_id: string) => {
  const url = `${REACT_APP_API_BASE_URL}/roles/${role_id}/permissions`;
  const { data, error, isLoading, mutate } = useSWR(encodeURI(url));

  return {
    permissions: data,
    error,
    isLoading,
    mutate,
  };
};

export default useRolePermissions;
